const TOGGLE_ACTIVATE = 'TOGGLE_ACTIVATE';

export default TOGGLE_ACTIVATE;
